const { onDOMContentLoaded } = require('./domEvents');

/**
 * Creates a MutationObserver that initializes matching components when they are
 * added to the DOM.
 * @param {string} componentSelector - A selector string used to identify the components to initialize.
 * @param {function(Element): void} componentInitFn - A callback function that will be invoked for each newly added component element.
 *   Receives the matching HTML element as its only argument.
 * @returns {MutationObserver} - The MutationObserver instance.
 */
function createAddedComponentObserver(componentSelector, componentInitFn) {
  return new MutationObserver((mutationsList) => {
    mutationsList.forEach(
      (mutation) =>
        mutation.type === 'childList' &&
        mutation.target.querySelectorAll &&
        [...mutation.target.querySelectorAll(componentSelector)].forEach(
          componentInitFn
        )
    );
  });
}

module.exports = function createComponentModule(
  componentSelector,
  initFunction,
  ignoreVueComponent = false
) {
  return {
    initAll() {
      onDOMContentLoaded(() => {
        // Initial configuration
        [...document.querySelectorAll(componentSelector)].forEach(
          this.initComponent
        );
        // Dinamically added
        createAddedComponentObserver(
          componentSelector,
          this.initComponent
        ).observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      });
    },

    initComponent(componentRootElement) {
      if (componentRootElement.dataset.initialized === 'true') return;
      if (ignoreVueComponent && componentRootElement.dataset.vue === 'true') {
        return;
      }

      initFunction(componentRootElement);

      // eslint-disable-next-line no-param-reassign
      componentRootElement.dataset.initialized = true;
    },
  };
};
